export const REDUCER_INDEX = 'absences';
export const BASE_URL = 'absences';

export const PATHS = {
  BASE_URL,
};

export const ABSENCE_TYPES = [
  {
    label: 'absences.type.medical.leave',
    value: 'medical_leave',
  },
  {
    label: 'absences.type.vacation',
    value: 'vacation',
  },
  {
    label: 'absences.type.personal.leave',
    value: 'personal_leave',
  },
  {
    label: 'absences.type.other',
    value: 'other',
  },
];

export const IS_EXCUSED_TYPES = [
  {
    label: 'general.yes',
    value: true,
  },
  {
    label: 'general.no',
    value: false,
  },
];

/**
 * Leave reason codes that only make sense as a justified absence (matrix reason select).
 * Vacation is registered via its own flow and is listed in ABSENCE_TYPES_REQUIRING_EXCUSED.
 */
export const JUSTIFIED_ABSENCE_REASON_CODES = [
  'medical_leave',
  'paid_leave',
  'unpaid_leave',
  'prenatal',
  'postnatal',
  'holiday',
];

/** Absence types that must be saved with isExcused === true. */
export const ABSENCE_TYPES_REQUIRING_EXCUSED = [...JUSTIFIED_ABSENCE_REASON_CODES, 'vacation'];

export const requiresExcusedAbsence = type =>
  typeof type === 'string' && ABSENCE_TYPES_REQUIRING_EXCUSED.includes(type);

/** Org-user Elastic search in AbsenceFormDrawer (min chars + debounce). */
export const ABSENCE_USER_SEARCH_MIN_LENGTH = 3;
export const ABSENCE_USER_SEARCH_DEBOUNCE_MS = 500;
